<div class="coworker-home-container">
  <div class=" header">
    <h3>{{ "coworker.favs.title" | translate }}</h3>
  </div>
  <div class="container">
    <div class="empty-fav">
      <img [src]="getHeartIcon" alt="" />
      <span>{{ "coworker.favs.no-favs" | translate }}</span>
    </div>

  </div>
  <div class="tabs">
    <cowing-tabs [active]="EActiveTab.Fav"></cowing-tabs>
  </div>
</div>